<app-navbar></app-navbar>
<div class="main container-fluid">
  <router-outlet></router-outlet>
</div>
